import { 
    Container, 
    Box,
    Spinner,
    Alert
} from "@amzn/awsui-components-react";
import { useLocation, useParams } from "react-router-dom";
import React, { useContext, useEffect, useState } from 'react';
import ServiceCollection from "src/services/ServiceCollection";
import MDASheetViewTable from "./sheets/MDASheetViewTable";
import {MDASheetViewHeading} from "src/components/multidimensional-allocation/sheets/MDASheetViewHeading";
import { GlobalAppContext } from "../App";
import { GLOBAL_ACTIONS } from "src/services/global/GlobalReducer";
import DynamicBreadcrumb from "src/models/navigation/DynamicBreadcrumb";
export interface MultidimensionalAllocationProps {
    services: ServiceCollection
}

export default function MDASheetView(props: MultidimensionalAllocationProps) {

    const { sheetId } = useParams<{sheetId: string}>();
    const { globalDispatch } = useContext(GlobalAppContext);
    const { pathname } = useLocation();
    // Initialize service
    const service = props.services.multidimensionalAllocationService;
    
    // State for version selection
    const [selectedVersion, setSelectedVersion] = useState<number | undefined>(undefined);
    const [fetchTrigger, setFetchTrigger] = useState(`fetch-${sheetId}`);
    
    // Fetch sheet data using the service
    const [sheetData, loading, error, availableVersions] = service.getMultiAllocationSheet(fetchTrigger, sheetId, selectedVersion);

    useEffect(() => {
        if (sheetData) {
            globalDispatch(GLOBAL_ACTIONS.SET_DYNAMIC_BREADCRUMB.withPayload(
                new DynamicBreadcrumb(pathname, 
                    sheetData.sheetName,
                    " ", // required as heading is dynamic and taken cared by this component.
                    " "  // non-ideal but requires a refactor in app-layout with little value.
                )))
            } } , [sheetData]
    );

    // Set initial version when sheet data is loaded
    useEffect(() => {
        if (sheetData && selectedVersion === undefined) {
            // Set to current version from the response
            const currentVersion =  sheetData.sheetVersion;
            setSelectedVersion(currentVersion);
        }
    }, [sheetData, selectedVersion]);

    // Handle version change
    const handleVersionChange = (selectedOption: any) => {
        const newVersion = parseInt(selectedOption.detail.selectedOption.value);
        setSelectedVersion(newVersion);
        setFetchTrigger(`fetch-${sheetId}-${newVersion}-${Date.now()}`);
    };



    // Loading state
    if (loading) {
        return (
            <Container>
                <div style={{ textAlign: 'center', padding: '2rem' }}>
                    <Spinner size="large" />
                    <Box variant="p">Loading allocation sheet...</Box>
                </div>
            </Container>
        );
    }

    // Error state
    if (error) {
        return (
            <Container>
                <Alert type="error" header="Error loading allocation sheet">
                    {error}
                </Alert>
            </Container>
        );
    }

    if (!sheetData) {
        return (
            <Container>
                <Alert type="warning" header="Sheet not found">
                    No allocation sheet found with ID: {sheetId}
                </Alert>
            </Container>
        );
    }

    return (
        <Container
            header={ 
                <MDASheetViewHeading 
                    sheetData={sheetData} 
                    availableVersions={availableVersions}
                    selectedVersion={selectedVersion}
                    onVersionChange={handleVersionChange}
                    loading={loading}
                />
            }
        >
            <MDASheetViewTable sheetData={sheetData} />
        </Container>
    );
}
